import { Service } from '../../../../../../types/services.types';
import { FieldValues } from './types';

export const mapToFieldValues = (
  service: Service | undefined | null,
): FieldValues => ({
  price: service?.price ?? 0,
  oldPrice: service?.oldPrice ?? 0,
  isBestPrice: service?.isBestPrice ?? false,
  recoveryTime: service?.recoveryTime ?? '',
  isFreeDiagnostic: service?.isFreeDiagnostic ?? false,
  isPopular: service?.isPopular ?? false,
  guarantee: service?.guarantee ?? 0,
  serviceInfoId: service?.serviceInfoId ?? '',
  slug: service?.slug ?? '',
  previewTextEn: service?.previewTextEn ?? '',
  previewTextRu: service?.previewTextRu ?? '',
  previewTextUk: service?.previewTextUk ?? '',
  previewTextPl: service?.previewTextPl ?? '',
});
